const article = {
    slug: "comme-des-garcons",
    category: "BRAND BUYBACK",
    listTitle: "コムデギャルソン買取",
    listDescription:
      "シーズン背景、コレクション性、希少性まで見て査定するEnclopediaのブランド別買取ページ。",
    seo: {
      title:
        "コムデギャルソン買取｜アーカイブ価値まで見て査定するEnclopedia",
      description:
        "COMME des GARÇONSの買取ならEnclopediaへ。シーズン背景、コレクション性、希少性まで見て査定します。高価買取を目指しつつ、まずはLINE事前査定から宅配買取へご案内します。",
      keyword:
        "コムデギャルソン 買取,COMME des GARCONS 買取,コムデギャルソン 高価買取,コムデギャルソン 宅配買取,COMME des GARÇONS HOMME PLUS 買取,JUNYA WATANABE 買取,noir kei ninomiya 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/comme-des-garcons",
    },
    hero: {
      label: "COMME DES GARÇONS BUYBACK",
      number: "01 / BUYBACK",
      titleLines: [
        "コムデギャルソン買取。",
        "アーカイブ価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、COMME des GARÇONSをブランド名だけで判断しません。\nシーズン背景、コレクション性、希少性まで確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで事前にご相談いただき、納得感のある宅配買取へつなげます。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref: "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "buyback",
        "archive valuation",
        "high-value purchase",
        "comme des garçons",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: ["ブランド名ではなく、", "服の背景まで見る。"],
      image: "media/archive_fashion/buyback1.png",
      imageAlt: "コムデギャルソン買取のメイン画像",
    },
    thesis: {
      text:
        "高価買取を目指しながら、シーズン背景とアーカイブ価値を査定に反映する。",
      keywords: ["season", "collection", "rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: ["コムデギャルソンの価値は、", "相場表だけでは測れない。"],
      body:
        "新しいシーズンの方が高値になりやすい場面はあります。\nただし、Enclopediaは年代だけで一律に判断しません。\nその服がどのシーズンに属し、どのようなコレクション性を持ち、いまどれほど希少かを見ながら、アイテム単位で査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: ["Enclopediaが重視する、", "3つの査定視点。"],
      items: [
        {
          number: "01",
          title: "シーズン背景を見る",
          text:
            "単にブランド名や型番だけで判断せず、どの時期の思想やテーマの中で生まれた服かを確認します。",
        },
        {
          number: "02",
          title: "コレクション性を見る",
          text:
            "ランウェイ登場品、シーズンの象徴性が強いデザイン、当時のテーマをよく示すピースは丁寧に評価します。",
        },
        {
          number: "03",
          title: "希少性を見る",
          text:
            "市場流通の少なさ、サイズ、保存状態、再入手難度まで含めて、個々のアイテム単位で査定します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET LINES",
      titleLines: ["COMME des GARÇONS全般を、", "幅広く査定します。"],
      items: [
        {
          tag: "LINE 01",
          title: "COMME des GARÇONS",
          text:
            "本ラインをはじめ、ブランドの核となるアーカイブや象徴的なコレクションピースを査定します。",
        },
        {
          tag: "LINE 02",
          title: "COMME des GARÇONS HOMME PLUS",
          text:
            "コレクション性が高く、Enclopediaが特に注力して見たいラインです。近年シーズンから過去作まで個別評価します。",
        },
        {
          tag: "LINE 03",
          title: "COMME des GARÇONS HOMME / COMME des GARÇONS HOMME DEUX",
          text:
            "日常着に近いラインでも、素材使い・年代・ディテールによって価値が変わるため丁寧に見ます。",
        },
        {
          tag: "LINE 04",
          title: "COMME des GARÇONS SHIRT / COMME des GARÇONS COMME des GARÇONS",
          text:
            "シャツ、ワンピース、女性向けラインも対象。ブランドの個性が強い品は積極的に査定します。",
        },
        {
          tag: "LINE 05",
          title: "JUNYA WATANABE",
          text:
            "構築性やコラボレーション性が高いアイテムを中心に、背景を踏まえて査定します。",
        },
        {
          tag: "LINE 06",
          title: "noir kei ninomiya",
          text:
            "カッティング、構造、加工が際立つ作品を評価。現行・過去シーズン問わずご相談いただけます。",
        },
        {
          tag: "LINE 07",
          title: "PLAY COMME des GARÇONS / Wallet等",
          text:
            "幅広いラインに対応します。ただし査定額は市場性・状態・需要により個別に判断します。",
        },
        {
          tag: "LINE 08",
          title: "その他関連ライン",
          text:
            "tricot、robe de chambre、GANRYU、BLACKなど、関連ブランドも内容に応じて査定します。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: ["高価買取につながりやすい、", "コムデギャルソン。"],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のような服を丁寧に見ます。",
      items: [
        {
          index: "01",
          title: "近年シーズンの人気アイテム",
          text:
            "現時点では比較的新しいシーズンの方が相場上高値になりやすい傾向があります。特に人気の強いアウター、ジャケット、ワンピースはご相談ください。",
        },
        {
          index: "02",
          title: "ランウェイ登場品・シーズンテーマを象徴する服",
          text:
            "コレクション全体の思想を担うルック、象徴性の強い柄や構造、ブランドの文脈が濃いアイテムは評価対象です。",
        },
        {
          index: "03",
          title: "希少アーカイブ・再入手しにくいピース",
          text:
            "古いだけで高くなるわけではありませんが、流通量が少なく、今なお評価される作品は個別に価値を見ます。",
        },
        {
          index: "04",
          title: "再構築・縮絨・変形・立体裁断などの代表的ディテール",
          text:
            "COMME des GARÇONSらしさが強く現れる技法や造形は、アイテムそのものの魅力として査定に反映します。",
        },
      ],
    },
    quote: {
      textLines: ["売れる服としてではなく、", "次へ受け継ぐ価値のある服として見る。"],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: ["一般的な査定で、", "見落とされやすい価値。"],
      intro:
        "Enclopediaは、ブランド古着としての流通性だけでなく、アーカイブとしての文脈も確認します。",
      items: [
        {
          index: "01",
          title: "年代だけで一律に見ない",
          text:
            "“古いから高い”“新しいから高い”ではなく、その服がどのような評価軸を持つかを確認します。",
        },
        {
          index: "02",
          title: "型番相場だけで終わらせない",
          text:
            "過去の取引価格だけでなく、今の需要、コレクション文脈、海外評価まで含めて個別に考えます。",
        },
        {
          index: "03",
          title: "売れるかだけでなく、残す価値を見る",
          text:
            "Enclopediaはアーカイブをレンタル・共有するサービスでもあります。次の着用者へ渡す価値がある服を丁寧に受け取ります。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: ["LINE事前査定から、", "宅配買取へ。"],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。宅配買取へ進む前に、おおまかな査定可否をご案内します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: ["相談しやすく、", "進めやすい宅配買取。"],
      intro:
        "LINEで相談してから進められるため、買取成立までの不安と手間を減らせます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、無駄な発送や手間を減らせます。",
        },
        {
          title: "送料は無料",
          text: "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: ["コムデギャルソン買取で、", "よくあるご質問。"],
      items: [
        {
          question: "どのラインのコムデギャルソンを買取していますか？",
          answer:
            "COMME des GARÇONS全般に対応しています。本ライン、COMME des GARCONS HOMME PLUS、COMME des GARCONS HOMME、COMME des GARCONS HOMME DEUX、SHIRT、COMME COMME、JUNYA WATANABE、noir kei ninomiyaなど幅広くご相談いただけます。",
        },
        {
          question: "古いアーカイブほど高く買い取ってもらえますか？",
          answer:
            "年代だけで一律には判断しません。現在は近年シーズンの方が高値になりやすい場合もありますが、過去作でもコレクション性・希少性・需要が高いものは個別に評価します。",
        },
        {
          question: "LINE査定をせずに宅配買取を申し込めますか？",
          answer:
            "申込自体は可能ですが、事前にLINE査定をご利用いただくことで、査定可否や大まかな方向性を確認しやすくなります。実務上もLINE事前査定をおすすめしています。",
        },
        {
          question: "キャンセルした場合、返送料はかかりますか？",
          answer:
            "基本的には無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
        },
        {
          question: "宅配キットは必ず使う必要がありますか？",
          answer:
            "必須ではありません。宅配キットは選択制のため、ご自身で梱包いただける場合はそのまま発送いただけます。",
        },
        {
          question: "査定では何を見ていますか？",
          answer:
            "状態や市場相場に加え、シーズン背景、コレクション性、希少性、現在の需要を総合して判断します。",
        },
      ],
    },
    finalCta: {
      titleLines: ["まずはLINEで、", "コムデギャルソンの価値をご相談ください。"],
      body:
        "宅配買取へ進む前に、写真で事前確認。\n背景まで見て査定するEnclopediaが、次の流通へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref: "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
